module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetMedium.045f771.jpg";